module.exports = __webpack_public_path__ + "static/media/noimage.98e3dabf.svg";